export const IMAGE_TYPE = {
  PNG: "image/png",
  JPEG: "image/jpeg",
  JPG: "image/jpg",
} as const;
